var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--stretch", style: _vm.styles },
    [
      _c("div", { staticClass: "rect rect-1", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-2", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-3", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-4", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-5", style: _vm.rectStyles }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }